import { createReducer, on } from '@ngrx/store';

import { StateUtils } from '@state/state-utils';
import * as TripActions from './trip.actions';
import { initialTripState, TripState } from './trip.state';

const tripReducer = createReducer<TripState>(
  initialTripState,

  on(TripActions.fetchTrips, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(TripActions.fetchTripById, (state) => ({
    ...state,
    fetchedAt: null,
  })),

  on(TripActions.fetchTripsSuccess, (state, { trips }) => ({
    ...state,
    fetchedAt: new Date(),
    trips: StateUtils.combineStateArr(state.trips, trips.data),
  })),
  on(TripActions.fetchTripsFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  })),

  on(TripActions.fetchTripByIdSuccess, (state, { trip }) => ({
    ...state,
    fetchedAt: new Date(),
    trips: StateUtils.combineState(state.trips, trip),
  })),
  on(TripActions.fetchTripByIdFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  }))
);

export { tripReducer };
